var map = {
	"./CG_first.jpg": "2800",
	"./backButton.jpg": "9196",
	"./frame.png": "3fe3",
	"./house.jpg": "63e9",
	"./jinja-.jpg": "3238",
	"./kawa.jpg": "6ce2",
	"./kawanooto.wav": "cd1c",
	"./lock_icon.png": "9e15",
	"./nameplate.png": "5aa4",
	"./onomatopa.png": "29cd",
	"./puzzle1.jpg": "52bb",
	"./puzzle2.jpg": "e9d3",
	"./puzzle3.jpg": "95a15",
	"./puzzle4.jpg": "d3b3",
	"./puzzle5.jpg": "9df8",
	"./puzzle6.jpg": "7d41",
	"./puzzle7.jpg": "60f2",
	"./puzzle8.jpg": "ee89",
	"./puzzle9.jpg": "7bd2",
	"./songs/puzzle1.mp3": "bbbd",
	"./songs/puzzle2.mp3": "8635",
	"./songs/puzzle3.mp3": "24b3",
	"./songs/puzzle4.mp3": "69c9",
	"./songs/puzzle5.mp3": "f7cc",
	"./songs/puzzle6.mp3": "f3cd",
	"./songs/puzzle7.mp3": "ce3e",
	"./songs/puzzle8.mp3": "8221",
	"./songs/puzzle9.mp3": "3c61"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a531";